import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _get from "lodash/get";

import PaymentTermForm from "./PaymentTermForm";
import { closeModalDialog } from "../../../../../../actions/layoutActions";
import propTypes from "../../../../../../constants/propTypes";
import {
  performCreateRequest,
  setReload,
} from "../../../../../../actions/dataComponentActions";

import { getDataComponent } from "../../../../../../reducers/dataComponentReducer";
import { handleRequestError } from "../../../../../../utils/formValidationUtils";
import { processCreateRequestStatus } from "../../../../../../utils/dataComponentUtils";
import { PAYMENT_TERMS_SELECT } from "../../../../../../constants/DataComponents";
import { reloadDataComponent } from "../../../../../../actions/initializeStoreActions";

export const dataComponentId = "paymentTermsGrid";

export const processRequestResponse = (
  prevDataComponent,
  dataComponent,
  closeModalDialog,
  setReload,
  reloadDataComponent,
  formikActions
) => {
  processCreateRequestStatus(prevDataComponent, dataComponent, {
    onSuccess: () => {
      closeModalDialog();
      setReload(dataComponentId, true);
      reloadDataComponent(PAYMENT_TERMS_SELECT);
    },
    onError: error => handleRequestError(error, formikActions),
  });
};

const CreatePaymentTermContainer = ({
  dataComponent,
  closeModalDialog,
  setReload,
  reloadDataComponent,
  paymentTerm: { id: sourceId, ...paymentTerm },
  performCreateRequest,
  loading,
  params,
}) => {
  const [prevDataComponent, setPrevDataComponent] = useState(dataComponent);
  const [formikActions, setFormikAction] = useState(null);

  useEffect(() => {
    setPrevDataComponent(dataComponent);
  }, [dataComponent]);

  useEffect(() => {
    processRequestResponse(
      prevDataComponent,
      dataComponent,
      closeModalDialog,
      setReload,
      reloadDataComponent,
      formikActions
    );
  });

  const handleCreate = useCallback(
    (instance, formikActions) => {
      performCreateRequest(dataComponentId, instance, params);
      setFormikAction(formikActions);
    },
    [performCreateRequest, params]
  );

  return (
    <PaymentTermForm
      initialValues={paymentTerm}
      onSubmit={handleCreate}
      loading={loading}
    />
  );
};

CreatePaymentTermContainer.defaultProps = {
  paymentTerm: {
    content: undefined,
    isArchived: false,
  },
};

CreatePaymentTermContainer.propTypes = {
  dataComponent: propTypes.dataComponent,
  closeModalDialog: PropTypes.func,
  paymentTerm: propTypes.paymentTerm,
  performCreateRequest: PropTypes.func,
  setReload: PropTypes.func,
  reloadDataComponent: PropTypes.func,
  loading: PropTypes.bool,
  params: PropTypes.shape({
    termContext: PropTypes.string,
    contextValue: PropTypes.string,
  }),
};

export const mapDispatchToProps = {
  closeModalDialog,
  performCreateRequest,
  setReload,
  reloadDataComponent,
};

const mapStateToProps = state => {
  const dataComponent = getDataComponent(dataComponentId, state);
  return {
    dataComponent,
    loading: _get(dataComponent, "requestState.create.loading"),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreatePaymentTermContainer);
